export enum FiChecklistScheduleType {
    Unknown = 0,
    Recurring = 1,
    OneTime = 2,
    OnDemand = 3,
    Audit = 4,
}
